export const printFunction = () => {
  const content = document.getElementById("printableArea").innerHTML;
  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
  <html>
    <head>
      <title>Print</title>
      <style>
        @page {
            size: A4;
        }

        @media print {
            body {
                font-family: Arial, sans-serif;
                padding: 0;
                margin: 20px;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              border: 1px solid #000;
              margin-top: 10px;
              page-break-inside: always;
              zoom: 0.8;
              font-size: 80%;
            }
            .no-border {
              border: none !important;
            }
            .no-padding {
              padding: 0 !important;
            }
            .font-semibold {
              font-weight: 600;
            }

            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }

            th, td {
                border: 0px;
                padding: 5px;
            }

            thead tr {
                border-bottom: 1px solid #000;
                font-weight: 700;
            }

            thead tr td, thead tr th {
                color: #000;
                font-size: 15px;
                padding: 3px 10px;
            }

            tbody tr td {
                font-size: 14px;
                padding: 3px 10px;
            }

            .no-print {
                display: none;
            }

            h4 {
                font-size: 20px;
                font-weight: 600;
                margin-bottom: 10px;
            }

            p {
                margin: 0;
                margin-bottom: 5px;
                font-size: 15px;
            }

            .last-row {border-top: 1px solid #000}
            .last-row td {font-weight: 700; font-size: 15px;}
            .center {text-align: center;}
            .end {text-align: right;}
            .start {text-align: left;}

            .top-head { font-weight: 400; border: 1px solid #000; text-align: left; border-bottom: none; }
            .top-head strong { font-weight: 600; }
            caption {font-size: 18px; font-weight: 600; padding: 10px;}
            .top-details {margin-bottom: -10px;}
            .top-details thead tr:last-child .top-head {border-bottom: none !important;}
            .top-details thead > tr:last-child > th.top-head {
              border-bottom: none !important;
            }
            .costing-total {margin-left: auto}
            .total-table {width: 50%;}
            .total-table tbody tr td {font-size: 16px, font-weight: 500;}

            p.table-bottom {margin-top: 10px;}

            .print-w-1 {
              width: 1% !important;
            }

            .print-w-2 {
              width: 2% !important;
            }

            .print-w-3 {
              width: 3% !important;
            }

            .print-w-4 {
              width: 4% !important;
            }

            .print-w-5 {
              width: 5% !important;
            }

            .print-w-6 {
              width: 6% !important;
            }

            .print-w-7 {
              width: 7% !important;
            }

            .print-w-8 {
              width: 8% !important;
            }

            .print-w-9 {
              width: 9% !important;
            }

            .print-w-10 {
              width: 10% !important;
            }

            .print-w-11 {
              width: 11% !important;
            }

            .print-w-12 {
              width: 12% !important;
            }

            .print-w-13 {
              width: 13% !important;
            }

            .print-w-14 {
              width: 14% !important;
            }

            .print-w-15 {
              width: 15% !important;
            }

            .print-w-16 {
              width: 16% !important;
            }

            .print-w-17 {
              width: 17% !important;
            }

            .print-w-18 {
              width: 18% !important;
            }

            .print-w-19 {
              width: 19% !important;
            }

            .print-w-20 {
              width: 20% !important;
            }

            .print-w-21 {
              width: 21% !important;
            }

            .print-w-22 {
              width: 22% !important;
            }

            .print-w-23 {
              width: 23% !important;
            }

            .print-w-24 {
              width: 24% !important;
            }

            .print-w-25 {
              width: 25% !important;
            }

            .print-w-26 {
              width: 26% !important;
            }

            .print-w-27 {
              width: 27% !important;
            }

            .print-w-28 {
              width: 28% !important;
            }

            .print-w-29 {
              width: 29% !important;
            }

            .print-w-30 {
              width: 30% !important;
            }

            .print-w-31 {
              width: 31% !important;
            }

            .print-w-32 {
              width: 32% !important;
            }

            .print-w-33 {
              width: 33% !important;
            }

            .print-w-34 {
              width: 34% !important;
            }

            .print-w-35 {
              width: 35% !important;
            }

            .print-w-36 {
              width: 36% !important;
            }

            .print-w-37 {
              width: 37% !important;
            }

            .print-w-38 {
              width: 38% !important;
            }

            .print-w-39 {
              width: 39% !important;
            }

            .print-w-40 {
              width: 40% !important;
            }

            .print-w-41 {
              width: 41% !important;
            }

            .print-w-42 {
              width: 42% !important;
            }

            .print-w-43 {
              width: 43% !important;
            }

            .print-w-44 {
              width: 44% !important;
            }

            .print-w-45 {
              width: 45% !important;
            }

            .print-w-46 {
              width: 46% !important;
            }

            .print-w-47 {
              width: 47% !important;
            }

            .print-w-48 {
              width: 48% !important;
            }

            .print-w-49 {
              width: 49% !important;
            }

            .print-w-50 {
              width: 50% !important;
            }

            .print-w-51 {
              width: 51% !important;
            }

            .print-w-52 {
              width: 52% !important;
            }

            .print-w-53 {
              width: 53% !important;
            }

            .print-w-54 {
              width: 54% !important;
            }

            .print-w-55 {
              width: 55% !important;
            }

            .print-w-56 {
              width: 56% !important;
            }

            .print-w-57 {
              width: 57% !important;
            }

            .print-w-58 {
              width: 58% !important;
            }

            .print-w-59 {
              width: 59% !important;
            }

            .print-w-60 {
              width: 60% !important;
            }

            .print-w-61 {
              width: 61% !important;
            }

            .print-w-62 {
              width: 62% !important;
            }

            .print-w-63 {
              width: 63% !important;
            }

            .print-w-64 {
              width: 64% !important;
            }

            .print-w-65 {
              width: 65% !important;
            }

            .print-w-66 {
              width: 66% !important;
            }

            .print-w-67 {
              width: 67% !important;
            }

            .print-w-68 {
              width: 68% !important;
            }

            .print-w-69 {
              width: 69% !important;
            }

            .print-w-70 {
              width: 70% !important;
            }

            .print-w-71 {
              width: 71% !important;
            }

            .print-w-72 {
              width: 72% !important;
            }

            .print-w-73 {
              width: 73% !important;
            }

            .print-w-74 {
              width: 74% !important;
            }

            .print-w-75 {
              width: 75% !important;
            }

            .print-w-76 {
              width: 76% !important;
            }

            .print-w-77 {
              width: 77% !important;
            }

            .print-w-78 {
              width: 78% !important;
            }

            .print-w-79 {
              width: 79% !important;
            }

            .print-w-80 {
              width: 80% !important;
            }

            .print-w-81 {
              width: 81% !important;
            }

            .print-w-82 {
              width: 82% !important;
            }

            .print-w-83 {
              width: 83% !important;
            }

            .print-w-84 {
              width: 84% !important;
            }

            .print-w-85 {
              width: 85% !important;
            }

            .print-w-86 {
              width: 86% !important;
            }

            .print-w-87 {
              width: 87% !important;
            }

            .print-w-88 {
              width: 88% !important;
            }

            .print-w-89 {
              width: 89% !important;
            }

            .print-w-90 {
              width: 90% !important;
            }

            .print-w-91 {
              width: 91% !important;
            }

            .print-w-92 {
              width: 92% !important;
            }

            .print-w-93 {
              width: 93% !important;
            }

            .print-w-94 {
              width: 94% !important;
            }

            .print-w-95 {
              width: 95% !important;
            }

            .print-w-96 {
              width: 96% !important;
            }

            .print-w-97 {
              width: 97% !important;
            }

            .print-w-98 {
              width: 98% !important;
            }

            .print-w-99 {
              width: 99% !important;
            }

            .print-w-100 {
              width: 100% !important;
            }
        }
      </style>
    </head>
    <body>
      ${content}
      <script>
        window.onload = () => {
          window.print();
          window.close();
        };
      </script>
    </body>
  </html>
  `);

  printWindow.document.close();
};

export const printLandscapeFunction = () => {
  const content = document.getElementById("printableArea").innerHTML;
  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
  <html>
    <head>
      <title>Print</title>
      <style>
        @page {
            size: A4 landscape;
        }

        @media print {
            body {
                font-family: Arial, sans-serif;
                padding: 0;
                margin: 20px;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              border: 1px solid #000;
              margin-top: 10px;
              page-break-inside: avoid;
              zoom: 0.8;
              font-size: 80%;
            }

            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }

            th, td {
                border: 0px;
                padding: 5px;
            }

            thead tr {
                border-bottom: 1px solid #000;
                font-weight: 700;
            }

            thead tr td, thead tr th {
                color: #000;
                font-size: 15px;
                padding: 3px 10px;
            }

            tbody tr td {
                font-size: 13px;
                padding: 3px 10px;
            }

            .no-print {
                display: none;
            }

            h4 {
                font-size: 20px;
                font-weight: 600;
                margin-bottom: 10px;
            }

            p {
                margin: 0;
                margin-bottom: 5px;
            }

            .print-w-1 {
              width: 1% !important;
            }

            .print-w-2 {
              width: 2% !important;
            }

            .print-w-3 {
              width: 3% !important;
            }

            .print-w-4 {
              width: 4% !important;
            }

            .print-w-5 {
              width: 5% !important;
            }

            .print-w-6 {
              width: 6% !important;
            }

            .print-w-7 {
              width: 7% !important;
            }

            .print-w-8 {
              width: 8% !important;
            }

            .print-w-9 {
              width: 9% !important;
            }

            .print-w-10 {
              width: 10% !important;
            }

            .print-w-11 {
              width: 11% !important;
            }

            .print-w-12 {
              width: 12% !important;
            }

            .print-w-13 {
              width: 13% !important;
            }

            .print-w-14 {
              width: 14% !important;
            }

            .print-w-15 {
              width: 15% !important;
            }

            .print-w-16 {
              width: 16% !important;
            }

            .print-w-17 {
              width: 17% !important;
            }

            .print-w-18 {
              width: 18% !important;
            }

            .print-w-19 {
              width: 19% !important;
            }

            .print-w-20 {
              width: 20% !important;
            }

            .print-w-21 {
              width: 21% !important;
            }

            .print-w-22 {
              width: 22% !important;
            }

            .print-w-23 {
              width: 23% !important;
            }

            .print-w-24 {
              width: 24% !important;
            }

            .print-w-25 {
              width: 25% !important;
            }

            .print-w-26 {
              width: 26% !important;
            }

            .print-w-27 {
              width: 27% !important;
            }

            .print-w-28 {
              width: 28% !important;
            }

            .print-w-29 {
              width: 29% !important;
            }

            .print-w-30 {
              width: 30% !important;
            }

            .print-w-31 {
              width: 31% !important;
            }

            .print-w-32 {
              width: 32% !important;
            }

            .print-w-33 {
              width: 33% !important;
            }

            .print-w-34 {
              width: 34% !important;
            }

            .print-w-35 {
              width: 35% !important;
            }

            .print-w-36 {
              width: 36% !important;
            }

            .print-w-37 {
              width: 37% !important;
            }

            .print-w-38 {
              width: 38% !important;
            }

            .print-w-39 {
              width: 39% !important;
            }

            .print-w-40 {
              width: 40% !important;
            }

            .print-w-41 {
              width: 41% !important;
            }

            .print-w-42 {
              width: 42% !important;
            }

            .print-w-43 {
              width: 43% !important;
            }

            .print-w-44 {
              width: 44% !important;
            }

            .print-w-45 {
              width: 45% !important;
            }

            .print-w-46 {
              width: 46% !important;
            }

            .print-w-47 {
              width: 47% !important;
            }

            .print-w-48 {
              width: 48% !important;
            }

            .print-w-49 {
              width: 49% !important;
            }

            .print-w-50 {
              width: 50% !important;
            }

            .print-w-51 {
              width: 51% !important;
            }

            .print-w-52 {
              width: 52% !important;
            }

            .print-w-53 {
              width: 53% !important;
            }

            .print-w-54 {
              width: 54% !important;
            }

            .print-w-55 {
              width: 55% !important;
            }

            .print-w-56 {
              width: 56% !important;
            }

            .print-w-57 {
              width: 57% !important;
            }

            .print-w-58 {
              width: 58% !important;
            }

            .print-w-59 {
              width: 59% !important;
            }

            .print-w-60 {
              width: 60% !important;
            }

            .print-w-61 {
              width: 61% !important;
            }

            .print-w-62 {
              width: 62% !important;
            }

            .print-w-63 {
              width: 63% !important;
            }

            .print-w-64 {
              width: 64% !important;
            }

            .print-w-65 {
              width: 65% !important;
            }

            .print-w-66 {
              width: 66% !important;
            }

            .print-w-67 {
              width: 67% !important;
            }

            .print-w-68 {
              width: 68% !important;
            }

            .print-w-69 {
              width: 69% !important;
            }

            .print-w-70 {
              width: 70% !important;
            }

            .print-w-71 {
              width: 71% !important;
            }

            .print-w-72 {
              width: 72% !important;
            }

            .print-w-73 {
              width: 73% !important;
            }

            .print-w-74 {
              width: 74% !important;
            }

            .print-w-75 {
              width: 75% !important;
            }

            .print-w-76 {
              width: 76% !important;
            }

            .print-w-77 {
              width: 77% !important;
            }

            .print-w-78 {
              width: 78% !important;
            }

            .print-w-79 {
              width: 79% !important;
            }

            .print-w-80 {
              width: 80% !important;
            }

            .print-w-81 {
              width: 81% !important;
            }

            .print-w-82 {
              width: 82% !important;
            }

            .print-w-83 {
              width: 83% !important;
            }

            .print-w-84 {
              width: 84% !important;
            }

            .print-w-85 {
              width: 85% !important;
            }

            .print-w-86 {
              width: 86% !important;
            }

            .print-w-87 {
              width: 87% !important;
            }

            .print-w-88 {
              width: 88% !important;
            }

            .print-w-89 {
              width: 89% !important;
            }

            .print-w-90 {
              width: 90% !important;
            }

            .print-w-91 {
              width: 91% !important;
            }

            .print-w-92 {
              width: 92% !important;
            }

            .print-w-93 {
              width: 93% !important;
            }

            .print-w-94 {
              width: 94% !important;
            }

            .print-w-95 {
              width: 95% !important;
            }

            .print-w-96 {
              width: 96% !important;
            }

            .print-w-97 {
              width: 97% !important;
            }

            .print-w-98 {
              width: 98% !important;
            }

            .print-w-99 {
              width: 99% !important;
            }

            .print-w-100 {
              width: 100% !important;
            }
        }
      </style>
    </head>
    <body>
      ${content}
      <script>
        window.onload = () => {
          window.print();
          window.close();
        };
      </script>
    </body>
  </html>
  `);

  printWindow.document.close();
};
